import { inject } from '@angular/core';
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import {
  hasRoutePermission,
  updateNavigationAccess,
} from '@core/utils/permission.util';

export const RoleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);

  if (!authService.isLoggedIn()) {
    return router.createUrlTree(['/auth/login']);
  }

  try {
    const permissions = authService.getUserPermission();

    // Update navigation menu access
    updateNavigationAccess(permissions);

    // Check if user has permission for current route
    if (!hasRoutePermission(permissions, state.url)) {
      return router.createUrlTree(['/not-found']);
    }

    return true;
  } catch (error) {
    console.error('Error in RoleGuard:', error);
    return router.createUrlTree(['/not-found']);
  }
};
